import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import {
  LevelTestChecker,
  usePrivate,
} from "@/contexts/PrivateContext";
import { AuthRole } from "@/services/shared/auth/auth.interfaces";

interface PrivateRouteProps {
  component: React.ComponentType;
  userRole?: AuthRole;
}

const PrivateRoute = (props: PrivateRouteProps) => {
  const { component: RouteComponent } = props;
  const { isLoaded, isLoggedIn, role } = usePrivate();
  const location = useLocation();
  const ALLOWED_LOCATIONS = ["/home", "/login", "/signup", "/logout"];

  // Wait for authentication check to complete
  if (!isLoaded) {
    return null; // or a loading spinner
  }

  // Check if user is logged in
  if (!isLoggedIn) {
    if (!ALLOWED_LOCATIONS.includes(location.pathname)) {
      return <Navigate to="/login" replace />;
    }
  }

  // Check if user has the required role
  if (props.userRole && role !== null && role !== props.userRole) {
    return <Navigate to="/login" replace />;
  }

  return (
    <>
      <LevelTestChecker />
      <RouteComponent />
    </>
  );
};

export default PrivateRoute;